<section fxLayout="column" fxLayout.gt-xs="row"
         fxLayoutGap="24px" fxLayoutAlign="space-around start">
  <figure fxFlex="1/3">
    <img alt="Step 1 on how to loan from Balikbayad!" src="/assets/how-it-works-step-1.jpg"/>
    <figcaption>
      <ul>
        <li>
          Read and understand Balikbayad loan features. For
          questions, check our FAQ page or email us for specific
          questions not covered in the FAQ.
        </li>
        <li>
          Fill our online inquiry form as accurately as possible or if you already have all the documents,
          you
          can directly visit our branch.
        </li>
        <li>We will reply to online inquiries within one to two business day.</li>
      </ul>
    </figcaption>
  </figure>
  <figure fxFlex="1/3">
    <img alt="Step 2 on how to loan from Balikbayad!" src="/assets/how-it-works-step-2.jpg"/>
    <figcaption>
      <ul>
        <li>Don't forget to bring all required original documents to process your loan application, if you
          do
          not, you will have to visit us again with completed documents.
        </li>
        <li>
          New Accounts Officer will go through our product features, and if you agree, enter your loan
          application into our system. No paper application is required.
        </li>
        <li>
          Credit verification requires one day processing. We will contact you once a decision has been
          made
          in the next business day.
        </li>
      </ul>
    </figcaption>
  </figure>
  <figure fxFlex="1/3">
    <img alt="Step 3 on how to loan from Balikbayad!" src="/assets/how-it-works-step-3.jpg"/>
    <figcaption>
      <ul>
        <li>Once approved, pick up a bank endorsement letter from Balikbayad, and proceed to open a checking
          account.
        </li>
        <li>Remember, opening and maintaining a checking account will not cost you anything.
        </li>
        <li>Return to Balikbayad with cheque book to complete loan contract. Carefully read and sign loan
          documents with Co-Maker, issue the required post dated cheques (PDCs) in exchange for releasing
          of
          loan.
        </li>
        <li>
          Encash cheque, or get cash from nearest bank or ATM
        </li>
      </ul>
    </figcaption>
  </figure>
</section>
